import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "invisible",
  ref: "description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading2 = _resolveComponent("Heading2")!
  const _component_Photo = _resolveComponent("Photo")!
  const _component_ContactList = _resolveComponent("ContactList")!
  const _component_NarrowContainer = _resolveComponent("NarrowContainer")!
  const _component_Paragraph = _resolveComponent("Paragraph")!
  const _component_Container = _resolveComponent("Container")!
  const _component_Section = _resolveComponent("Section")!

  return (_openBlock(), _createBlock(_component_Section, {
    id: "about",
    border: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Container, null, {
        default: _withCtx(() => [
          _createVNode(_component_Heading2, { class: "mb-12" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("about.header")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_NarrowContainer, { class: "md:flex md:items-center mb-12" }, {
            default: _withCtx(() => [
              _createVNode(_component_Photo, { class: "md:w-1/2 md:pr-6 mb-12 md:mb-0" }),
              _createVNode(_component_ContactList, {
                class: "md:w-1/2 md:pl-6",
                entities: _ctx.entities
              }, null, 8, ["entities"])
            ]),
            _: 1
          }),
          _createVNode(_component_NarrowContainer, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_Paragraph, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("about.description")), 1)
                  ]),
                  _: 1
                })
              ], 512)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}